module.exports = __webpack_public_path__ + "images/play_large@2x.png?364b4b59";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/play_large@2x.png
// module id = 678
// module chunks = 7